<template>
    <div class="no-chat-found-container">
        <div class="live-support-image">
            <img src="/static/img/liveSupportChat.svg" />
        </div>
        <div class="custom-card">
            <div class="card">
                <p style="font-size: 20px">{{ $t("message.noSystemMessage") }}</p>
                <p>{{ $t("message.supsisCustomerService") }}</p>
                <p>{{ $t("message.supsisClickExperience") }}</p>
            </div>
            <div class="wrap">
                <a class="button" :href="visitorScreenUrl" target="_blank">
                    <span>{{ $t("message.customerPage") }}</span>
                    <img class="message-img" src="/static/img/message-smile-square-svgrepo-com.svg" />
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faCog, faComment, faCommentAlt, faCommentDots, faEye } from "@fortawesome/free-solid-svg-icons";

import * as _ from "lodash";
import { log2 } from "../utils/log2";
import { fakeConversation, tableSorter } from "../utils/utils";

import { i18n } from "../language";
import { sendSocketMessage, socketMessageStream } from "../utils/socketStream";
import moment from "moment";
import { getPersistenceData, setPersistenceData } from "../utils/persistenceStorage";

library.add(faCommentDots, faCog, faEye, faComment, faCommentAlt);

const log = log2("NoCahatFound");
export default {
    name: "noChatFound",
    computed: {
        ...mapState({
            site: (state) => state.site.site,
            visitorScreenUrl: (state) => {
                const isProduction = process.env.ENVIRONMENT === "production";
                const isStage = process.env.ENVIRONMENT === "stage";
                let siteAlias = (state.site.site.customerClientAddress || "").replace(".visitor.supsis.live", "");
                const protocol = isProduction || isStage ? "https" : "http";
                if (siteAlias === "visitor.supsis.live") siteAlias = "demo-site.supsis.live?customer=supsis";
                else siteAlias = "demo-site.supsis.live?customer=" + siteAlias;
                const hostname = isProduction
                    ? siteAlias
                    : isStage
                    ? `demo-site.supsis.live?url=${protocol}://${
                          state.site.site.customerClientAddress || "betavisitor.supsis.live"
                      }/static/js/loader.js`
                    : "localsite.supsis.live?customer=local";
                return `${protocol}://${hostname}`;
            },
        }),
    },
};
</script>

<style lang="scss" scoped>
.no-chat-found-container {
    text-align: center;
}

.live-support-image {
    display: inline-block;
}

.live-support-image img {
    vertical-align: middle;
    width: 400px;
    height: auto;
}

.custom-card {
    display: inline-block;
    vertical-align: middle;
    margin-left: 50px;
    padding: 10px;
}

.wrap {
    margin-top: 40px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.message-img {
    width: 20px;
    height: 20px;
    margin-left: 10px;
}

.button {
    min-width: 250px;
    min-height: 30px;
    font-size: 12px;
    letter-spacing: 1.3px;
    font-weight: 700;
    color: #fff !important;
    background: #faa566;
    background: linear-gradient(90deg, rgb(250, 165, 102) 0%, rgb(250, 165, 102) 100%);
    border: none;
    border-radius: 1000px;
    box-shadow: 12px 12px 24px rgb(250, 165, 102);
    transition: all 0.3s ease-in-out 0s;
    cursor: pointer;
    outline: none;
    position: relative;
    padding: 10px;
}

.card {
    border-radius: 10px;
    width: 400px;
    height: 180px;
    padding: 35px;
    position: relative;
    z-index: 0;
    overflow: hidden;
    transition: 0.6s ease-in;
}

.card::before {
    content: "";
    position: absolute;
    z-index: -1;
    top: -15px;
    right: -15px;
    background: #faa566;
    height: 220px;
    width: 25px;
    border-radius: 32px;
    transform: scale(1);
    transform-origin: 50% 50%;
    transition: transform 0.25s ease-out;
}

.card p {
    font-size: 16px;
}
</style>
